import { mapState } from 'vuex'
import { sortBy, groupBy, compact } from 'lodash'
import moment from 'moment'
import REGIONS from './RegionsValues'

export const CALENDAR_REPORTS = require('@/reports.json').choices

export const PROGRAM_PICTURE_PLACEHOLDER = 'vadimm-src/place-holder-program.jpg'

export const MATRIMONIAL_STATUS_CHOICES = {
  'community-reduite': {value: 'community-reduite', label: 'Communauté réduite aux acquêts', short_label: 'Com. réduite aux acquêts'},
  separation: {value: 'separation', label: 'Séparation de biens', short_label: 'Sép. de biens'},
  participation: {value: 'participation', label: 'Participation aux acquêts', short_label: 'Part. aux acquêts'},
  community: {value: 'community', label: 'Communauté de biens et acquêts', short_label: 'Com. de biens et acquêts'},
  'community-universelle': {value: 'community-universelle', label: 'Communauté universelle', short_label: 'Com. universelle'},
  indivision: {value: 'indivision', label: 'Indivision', short_label: 'Indivision'}
}

export const FAMILY_SITUATION_CHOICES = {
  single: {value: 'single', label: 'Célibataire'},
  married: {value: 'married', label: 'Marié/Mariée'},
  pacs: {value: 'pacs', label: 'PACS'},
  concubinage: {value: 'concubinage', label: 'Concubinage'},
  divorced: {value: 'divorced', label: 'Divorcé'},
  widower: {value: 'widower', label: 'Veuf/Veuve'}
}

export const PROFIL_TYPES_CHOICES = {
  admin: {value: 'admin', label: 'Admin', order: 1},
  manager: {value: 'manager', label: 'Manager', order: 2},
  seller: {value: 'seller', label: 'Vendeur', order: 3},
  sector_manager: {value: 'sector_manager', label: 'Responsable Secteur', order: 4},
  manager_ext: {value: 'manager_ext', label: 'Manager Ext.', order: 5},
  seller_ext: {value: 'seller_ext', label: 'Vendeur Ext.', order: 6},
  operator: {value: 'operator', label: 'Opérateur', order: 7},
  editor: {value: 'editor', label: 'Editeur', order: 8}
}

export const TAX_DISPOSITIFS_CHOICES = {
  pinel: {value: 'pinel', label: 'Pinel', valid: true},
  lmp_lmnp: {value: 'lmp_lmnp', label: 'LMP/LMNP', valid: true},
  deficit_foncier: {value: 'deficit_foncier', label: 'Déficit foncier', valid: true},
  monuments_historiques: {value: 'monuments_historiques', label: 'Monument historique', short_label: 'Mnt. Hist.', valid: true},
  anru: {value: 'anru', label: 'ANRU', valid: false},
  malraux: {value: 'malraux', label: 'Malraux', valid: true},
  ephad: {value: 'ephad', label: 'EPHAD', valid: false},
  pls: {value: 'pls', label: 'Plan Social Loc.', valid: false},
  ptz: {value: 'ptz', label: 'Prêt taux zéro', valid: false},
  'tva_5.5': {value: 'tva_5.5', label: 'TVA à 5.5', valid: false},
  'regime_commun': {value: 'regime_commun', label: 'Régime commun', valid: false},
  'nue_propriete/demembrement': {value: 'nue_propriete/demembrement', label: 'Nue Propriété/Démembrement', valid: true},
  censi_bouvard: {value: 'censi_bouvard', label: 'Censi Bouvard', valid: false}
}

export const PROGRAM_CERTIFICATIONS = {
  dolce_vita: {value: 'dolce_vita', label: 'Dolce Vita', img: 'static/engie.png'},
  vivrelec: {value: 'vivrelec', label: 'VIVRELEC', img: 'static/vivrelec.png'},
  qualitel: {value: 'qualitel', label: 'Qualitel', img: 'static/qualitel.png'},
  fpi: {value: 'fpi', label: 'FPI', img: 'static/federation-promoteur-immobilier.png'},
  nf_logement: {value: 'nf_logement', label: 'NF Logement', img: 'static/nf.png'},
  bbc: {value: 'bbc', label: 'BBC', img: 'static/bbc.png'},
  rt2012: {value: 'rt2012', label: 'RT2012', img: 'static/RTt2012.png'},
  promotolec: {value: 'promotolec', label: 'Promotelec', img: 'static/promotelec.png'},
  qualigaz: {value: 'qualigaz', label: 'Qualigaz', img: 'static/qualigaz.png'},
  certification_patrimoine_habitat: {
    value: 'certification_patrimoine_habitat',
    label: 'Certif. Patrimoine Habitat',
    img: 'static/certificatiopn-patrimoine-habitat.png'
  },
  edf_bleu_ciel: {value: 'edf_bleu_ciel', label: 'EDF Bleu Ciel', img: 'static/engie.png'},
  habitat_et_environnement: {value: 'habitat_et_environnement', label: 'Habitat et Environnement', img: 'static/habitat-environnement.png'},
  hqe: {value: 'hqe', label: 'HQE', img: 'static/hqe.png'},
  gdf: {value: 'gdf', label: 'GDF', img: 'static/engie.png'}
}

export const STATUS_CHOICES = {
  draft: {value: 'draft', label: 'Brouillon', needProfile: ['admin']},
  available: {value: 'available', label: 'Disponible'},
  optioned: {value: 'optioned', label: 'Optionné'},
  reserved: {value: 'reserved', label: 'Réservé'},
  sold: {value: 'sold', label: 'Acté'},
  canceled_by_admin: {value: 'canceled_by_admin', label: 'Annulé'},
  canceled_by_seller: {value: 'canceled_by_seller', label: 'Annulé'}
}

export const WORKFLOW_CHOICES = {
  draft: {value: 'draft', label: 'Brouillon', needProfile: ['admin']},
  available: {value: 'available', label: 'Visible'},
  private: {value: 'private', label: 'Privé'},
  archived: {value: 'archived', label: 'Archivé', needProfile: ['admin']}
}

export const PROGRAM_PROGRESS_STEP_CHOICES = {
  avant_premiere: {value: 'avant_premiere', label: {FRA: 'Avant-Première', MAR: 'Avant-Première'}, country: ['FRA', 'MAR']},
  nouvelle_realisation: {value: 'nouvelle_realisation', label: {FRA: 'Nouvelle réalisation', MAR: 'Nouvelle réalisation'}, country: ['FRA', 'MAR']},
  lancement: {value: 'lancement', label: {FRA: 'Lancement commercial', MAR: 'Lancement commercial'}, country: ['FRA', 'MAR']},
  depot_pc: {value: 'depot_pc', label: {FRA: 'Dépot de PC', MAR: 'Dépot de PC'}, country: ['FRA', 'MAR']},
  pc_purge: {value: 'pc_purge', label: {FRA: 'PC purgé', MAR: 'PC purgé'}, country: ['FRA', 'MAR']},
  travaux_en_cours: {value: 'travaux_en_cours', label: {FRA: 'Travaux en cours', MAR: 'Travaux en cours'}, country: ['FRA', 'MAR']},
  livraison_imminente: {value: 'livraison_imminente', label: {FRA: 'Livraison imminente', MAR: 'Livraison imminente'}, country: ['FRA', 'MAR']},
  livraison_en_cours: {value: 'livraison_en_cours', label: {FRA: 'Livraison en cours', MAR: 'Livraison en cours'}, country: ['FRA', 'MAR']},
  actable: {value: 'actable', label: {FRA: 'Programme actable', MAR: 'Titre foncier disponible'}, country: ['FRA', 'MAR']}
}

export const LOT_NATURES = {
  flat: {value: 'flat', label: {FRA: 'Appt.', MAR: 'Appt.'}, country: ['FRA', 'MAR']},
  house: {value: 'house', label: {FRA: 'Maison', MAR: 'Maison'}, country: ['FRA']},
  villa: {value: 'villa', label: {FRA: 'Villa', MAR: 'Villa'}, country: ['MAR']},
  field: {value: 'field', label: {FRA: 'Terrain', MAR: 'Terrain'}, country: ['FRA', 'MAR']},
  commercial: {value: 'commercial', label: {FRA: 'Local com', MAR: 'Local com'}, country: ['FRA', 'MAR']},
  parking: {value: 'parking', label: {FRA: 'Parking', MAR: 'Parking'}, country: ['FRA', 'MAR'], hide: true}
  // duplex: {value: 'duplex', label: 'Duplex'},
  // villa: {value: 'villa', label: 'Villa'},
  // office: {value: 'office', label: 'Bureau'},
  // attica: {value: 'attica', label: 'Attique'}
}

export const LOT_TYPES = {
  T1: {value: 'T1', label: {FRA: 'T1', MAR: 'Studio'}, country: ['FRA', 'MAR']},
  T1_bis: {value: 'T1_bis', label: {FRA: 'T1 bis', MAR: 'Studio'}, country: ['FRA']},
  T1_duplex: {value: 'T1_duplex', label: {FRA: 'T1 duplex', MAR: 'Studio duplex'}, country: ['FRA', 'MAR']},
  T2: {value: 'T2', label: {FRA: 'T2', MAR: '2 chambres'}, country: ['FRA', 'MAR']},
  T2_bis: {value: 'T2_bis', label: {FRA: 'T2 bis', MAR: '2 chambres'}, country: ['FRA']},
  T2_duplex: {value: 'T2_duplex', label: {FRA: 'T2 duplex', MAR: '2 chambres duplex'}, country: ['FRA', 'MAR']},
  T3: {value: 'T3', label: {FRA: 'T3', MAR: '3 chambres'}, country: ['FRA', 'MAR']},
  T3_bis: {value: 'T3_bis', label: {FRA: 'T3 bis', MAR: '3 chambres'}, country: ['FRA']},
  T3_duplex: {value: 'T3_duplex', label: {FRA: 'T3 duplex', MAR: '3 chambres duplex'}, country: ['FRA', 'MAR']},
  T4: {value: 'T4', label: {FRA: 'T4', MAR: '4 chambres'}, country: ['FRA', 'MAR']},
  T4_bis: {value: 'T4_bis', label: {FRA: 'T4 bis', MAR: '4 chambres'}, country: ['FRA']},
  T4_duplex: {value: 'T4_duplex', label: {FRA: 'T4 duplex', MAR: '4 chambres duplex'}, country: ['FRA', 'MAR']},
  T5: {value: 'T5', label: {FRA: 'T5', MAR: '5 chambres'}, country: ['FRA', 'MAR']},
  T5_bis: {value: 'T5_bis', label: {FRA: 'T5 bis', MAR: '5 chambres'}, country: ['FRA']},
  T5_duplex: {value: 'T5_duplex', label: {FRA: 'T5 duplex', MAR: '5 chambres duplex'}, country: ['FRA', 'MAR']},
  'T6': {value: 'T6+', label: {FRA: 'T6 et plus', MAR: '6 chambres'}, country: []},
  'T6+': {value: 'T6+', label: {FRA: 'T6 et plus', MAR: '6 chambres'}, country: ['FRA', 'MAR']}
}

export const LOT_TYPES_FILTER = {
  T1: {value: 'T1', label: {FRA: 'T1', MAR: 'Studio'}},
  T2: {value: 'T2', label: {FRA: 'T2', MAR: '2 chambres'}},
  T3: {value: 'T3', label: {FRA: 'T3', MAR: '3 chambres'}},
  T4: {value: 'T4', label: {FRA: 'T4', MAR: '4 chambres'}},
  T5: {value: 'T5', label: {FRA: 'T5', MAR: '5 chambres'}},
  'T6+': {value: 'T6+', label: {FRA: 'T6 et plus', MAR: '6 chambres et plus'}}
}

export const LOT_DEFAULT_TYPE_LABEL = {
  FRA: 'pièce',
  MAR: 'chambre'
}

export const LOT_EXPOSURES = {
  north: {value: 'north', label: 'Nord', short_label: 'N'},
  south: {value: 'south', label: 'Sud', short_label: 'S'},
  east: {value: 'east', label: 'Est', short_label: 'E'},
  west: {value: 'west', label: 'Ouest', short_label: 'O'},
  'north-west': {value: 'north-west', label: 'Nord-Ouest', short_label: 'NO'},
  'north-east': {value: 'north-east', label: 'Nord-Est', short_label: 'NE'},
  'south-east': {value: 'south-east', label: 'Sud-Est', short_label: 'SE'},
  'south-west': {value: 'south-west', label: 'Sud-Ouest', short_label: 'SO'}
}

export const LOT_FLOORS = {
  'rdj': {value: 'rdj', label: 'Rez de jardin'},
  'rdc': {value: 'rdc', label: 'Rdc'},
  'R+1': {value: 'R+1', label: 'R+1'},
  'R+2': {value: 'R+2', label: 'R+2'},
  'R+3': {value: 'R+3', label: 'R+3'},
  'R+4': {value: 'R+4', label: 'R+4'},
  'R+5': {value: 'R+5', label: 'R+5'},
  'R+6': {value: 'R+6', label: 'R+6'},
  'R>6': {value: 'R>6', label: 'R>6'},
  'R+': {value: 'R+', label: 'Plus'},
  'R-1': {value: 'R-1', label: 'R-1'},
  'N0': {value: 'N0', label: 'N0'},
  'N1': {value: 'N1', label: 'N1'},
  'N2': {value: 'N2', label: 'N2'},
  'N3': {value: 'N3', label: 'N3'},
  'N4': {value: 'N4', label: 'N4'},
  'N5': {value: 'N5', label: 'N5'},
  'N6': {value: 'N6', label: 'N6'}
}

export const LOT_ANNEX_TYPES = {
  'pool': {value: 'pool', label: 'Piscine'},
  'parking': {value: 'parking', label: 'Parking'},
  'parking_ext': {value: 'parking_ext', label: 'parking ext.', hideInFilter: true},
  'parking_int': {value: 'parking_int', label: 'parking int.', hideInFilter: true},
  'garage': {value: 'garage', label: 'Garage'},
  'balcony': {value: 'balcony', label: 'Balcon'},
  'terrace': {value: 'terrace', label: 'Terrasse'},
  'garden': {value: 'garden', label: 'Jardin'},
  'cellar': {value: 'cellar', label: 'Cave'},
  'larder': {value: 'larder', label: 'Cellier'},
  'bike_local': {value: 'bike_local', label: 'Local(s) à vélo'},
  'loggia': {value: 'loggia', label: 'Loggia'},
  'other': {value: 'other', label: 'Autre'}
}

export const OPTION_STATUS = {
  'pending': {value: 'pending', label: 'En attente'},
  'approved': {value: 'approved', label: 'Accepté'},
  'waiting_list': {value: 'waiting_list', label: 'En liste d\'attente'},
  'refused': {value: 'refused', label: 'Refusé'},
  'expired': {value: 'expired', label: 'Expiré'},
  'reserved': {value: 'reserved', label: 'Réservation'},
  'sold': {value: 'sold', label: 'Acté'},
  'canceled_by_admin': {value: 'canceled_by_admin', label: 'Annulé'},
  'canceled_by_seller': {value: 'canceled_by_seller', label: 'Annulé'}
}

export const ADV_STATUS = {
  'reserved': {value: 'reserved', label: 'Réservation'},
  'sold': {value: 'sold', label: 'Acté'},
  'canceled_by_admin': {value: 'canceled_by_admin', label: 'Annulé'}
}

export const DENUNCIATION_STATUS = {
  'approved': {value: 'approved', label: 'Acceptée'},
  'pending': {value: 'pending', label: 'En attente'},
  'refused': {value: 'refused', label: 'Refusée'}
}

export const CONTACT_CSP = {
  retirement: {value: 'retirement', label: 'Retraité'},
  unemployed: {value: 'unemployed', label: 'Sans profession'},
  official: {value: 'official', label: 'Fonctionnaire'},
  artisan: {value: 'artisan', label: 'Artisan'},
  executive: {value: 'executive', label: 'Cadre'},
  worker: {value: 'worker', label: 'Ouvrier'},
  employee: {value: 'employee', label: 'Employé'},
  technician: {value: 'technician', label: 'Technicien'},
  representative: {value: 'representative', label: 'Représentant'},
  liberal: {value: 'liberal', label: 'P. libérale'},
  others: {value: 'others', label: 'Divers'}
}

export const CONTACT_RESEARCH_TYPE = {
  main_residence: {value: 'main_residence', label: 'Résidence princ.'},
  secondary_residence: {value: 'secondary_residence', label: 'Résidence sec.'},
  invest: {value: 'invest', label: 'Investissement'},
  other: {value: 'other', label: 'Autre'}
}

export const CONTACT_RESEARCH_FUNDING_TYPE = {
  cash: {value: 'cash', label: 'Paiemt. comptant'},
  bank_loan: {value: 'bank_loan', label: 'Prêt bancaire'},
  other: {value: 'other', label: 'Autre'}
}

export const PROGRAM_DOCUMENTS_NAME = [
  'Brochure du programme',
  'Plaquette Commerciale',
  'Descriptif du programme',
  'Dossier de réservation',
  'Plan de masse',
  'Plan de masse général',
  'Plan du parking',
  'Plan de situation',
  'Plan des annexes',
  'État des risques',
  'Offre commerciale',
  'Argumentaire de vente'
]
export const LOT_DOCUMENTS_NAME = [
  'Plan de composition',
  'Plan d\'implantation',
  'Descriptif du logement',
  'Plan du réseau',
  'Cahier des charges',
  'Statut association syndicale',
  'Règlement du lotissement',
  'Contrat de réservation du terrain',
  'Promesse de vente'
]

export const ORIGIN_TYPE = {
  multidiffusion: {value: 'multidiffusion', label: 'Multidifusion'},
  internal: {value: 'internal', label: 'Vendeur'},
  operator: {value: 'operator', label: 'Opérateur'},
  external: {value: 'external', label: 'Partenaire'},
  lead: {value: 'lead', label: 'Lead'}
}

export const ADV_DESTINATIONS = {
  invest: {value: 'invest', label: 'Investissement'},
  main_residence: {value: 'main_residence', label: 'Résidence principale'},
  secondary_residence: {value: 'secondary_residence', label: 'Résidence secondaire'},
  other: {value: 'other', label: 'Autre'}
}

export const VIDEO_PROVIDER = {
  youtube: {value: 'youtube', label: 'Youtube'},
  vimeo: {value: 'vimeo', label: 'Vimeo'}
}

export const MAP_STYLE = [
  {featureType: 'poi', elementType: 'all', stylers: [{hue: '#ff0000'}, {visibility: 'off'}]}
]

export const SEARCH_BUDGET_MAX = {
  100000: {value: 100000, label: '0 - 100k', currency: 'EUR'},
  200000: {value: 200000, label: '0 - 200k', currency: 'EUR'},
  300000: {value: 300000, label: '0 - 300k', currency: 'EUR'},
  400000: {value: 400000, label: '0 - +400k', currency: 'EUR'},
  1000000: {value: 1000000, label: '0 - 1 000k', currency: 'MAD'},
  2000000: {value: 2000000, label: '0 - 2 000k', currency: 'MAD'},
  3000000: {value: 3000000, label: '0 - 3 000k', currency: 'MAD'},
  4000000: {value: 4000000, label: '0 - +4 000k', currency: 'MAD'}
}

export const STOCK_BUDGET = [
  {label: '0', currency: ['EUR', 'MAD']},
  {label: '50', currency: 'EUR'},
  {label: '100', currency: 'EUR'},
  {label: '150', currency: 'EUR'},
  {label: '200', currency: 'EUR'},
  {label: '250', currency: 'EUR'},
  {label: '300', currency: 'EUR'},
  {label: '350', currency: 'EUR'},
  {label: '400', currency: 'EUR'},
  {label: '500', currency: 'MAD'},
  {label: '1000', currency: 'MAD'},
  {label: '1500', currency: 'MAD'},
  {label: '2000', currency: 'MAD'},
  {label: '2500', currency: 'MAD'},
  {label: '3000', currency: 'MAD'},
  {label: '3500', currency: 'MAD'},
  {label: '4000', currency: 'MAD'}
]
export const STOCK_BUDGET_IGNORE = [
  {label: '50', currency: 'EUR'},
  {label: '150', currency: 'EUR'},
  {label: '250', currency: 'EUR'},
  {label: '350', currency: 'EUR'},
  {label: '500', currency: 'MAD'},
  {label: '1500', currency: 'MAD'},
  {label: '2500', currency: 'MAD'},
  {label: '3500', currency: 'MAD'}
]
export const STOCK_BUDGET_STEP = [
  {value: 25000, currency: 'EUR'},
  {value: 250000, currency: 'MAD'}
]

export const REMINDER_DATE = {
  today: {value: moment().startOf('day').format('YYYY/MM/DD'), label: 'Aujourd\'hui'},
  tomorrow: {value: moment().startOf('day').add(1, 'd').format('YYYY/MM/DD'), label: 'Demain'},
  oneWeek: {value: moment().startOf('day').add(1, 'w').format('YYYY/MM/DD'), label: '1 semaine'},
  oneMonth: {value: moment().startOf('day').add(1, 'M').format('YYYY/MM/DD'), label: '1 mois'}
}

export const DEFAULT_STATE_LABEL = [
  { label: 'département', error: 'Aucun département trouvé.', country: 'FRA' },
  { label: 'province', error: 'Aucune province trouvée.', country: 'MAR' }
]

export default {
  filters: {
    matrimonalStatusLabel (val) {
      if (val in MATRIMONIAL_STATUS_CHOICES) {
        return MATRIMONIAL_STATUS_CHOICES[val].label
      }
      return null
    },
    familySituationLabel (val) {
      if (val in FAMILY_SITUATION_CHOICES) {
        return FAMILY_SITUATION_CHOICES[val].label
      }
      return null
    },
    taxDispositifLabel (val) {
      if (val in TAX_DISPOSITIFS_CHOICES) {
        return TAX_DISPOSITIFS_CHOICES[val].label
      }
      return null
    },
    taxDispositifLabelShort (val) {
      if (val in TAX_DISPOSITIFS_CHOICES) {
        return TAX_DISPOSITIFS_CHOICES[val].short_label || TAX_DISPOSITIFS_CHOICES[val].label
      }
      return null
    },
    programCertificationLabel (val) {
      if (val in PROGRAM_CERTIFICATIONS) {
        return PROGRAM_CERTIFICATIONS[val].label
      }
      return null
    },
    programCertificationImage (val) {
      if (val in PROGRAM_CERTIFICATIONS) {
        return PROGRAM_CERTIFICATIONS[val].img
      }
      return null
    },
    profilTypeLabel (val) {
      if (val in PROFIL_TYPES_CHOICES) {
        return PROFIL_TYPES_CHOICES[val].label
      }
      return null
    },
    denunciationStatusLabel (val) {
      if (val in DENUNCIATION_STATUS) {
        return DENUNCIATION_STATUS[val].label
      }
      return null
    },
    contactCspLabel (val) {
      if (val in CONTACT_CSP) {
        return CONTACT_CSP[val].label
      }
      return null
    },
    annexTypeLabel (val) {
      if (val in LOT_ANNEX_TYPES) {
        return LOT_ANNEX_TYPES[val].label
      }
      return val
    },
    parkingTypeLabel (val) {
      if (val in LOT_ANNEX_TYPES) {
        return LOT_ANNEX_TYPES[val].label
      }
      return val
    },
    statusLabel (val) {
      if (val in STATUS_CHOICES) {
        return STATUS_CHOICES[val].label
      }
      return null
    },
    workflowLabel (val) {
      if (val in WORKFLOW_CHOICES) {
        return WORKFLOW_CHOICES[val].label
      }
      return null
    },
    exposureLabel (val) {
      if (val in LOT_EXPOSURES) {
        return LOT_EXPOSURES[val].label
      }
      return null
    },
    exposuresLabel (val) {
      if (val && Array.isArray(val)) {
        let arr = val.slice()
        arr = arr.map(x => {
          return LOT_EXPOSURES[x].label
        })
        return arr.join(' / ')
      }
      return null
    },
    exposuresShortLabel (val) {
      if (val && Array.isArray(val)) {
        let arr = val.slice()
        arr = arr.map(x => {
          if (x in LOT_EXPOSURES) {
            return LOT_EXPOSURES[x].short_label || LOT_EXPOSURES[x].label
          }
        })
        return compact(arr).join('/')
      }
      return null
    },
    optionStatusLabel (val) {
      if (val in OPTION_STATUS) {
        return OPTION_STATUS[val].label
      }
      return null
    },
    contactResearchLabel (val) {
      if (val in CONTACT_RESEARCH_TYPE) {
        return CONTACT_RESEARCH_TYPE[val].label
      }
      return null
    },
    contactResearchFundingLabel (val) {
      if (val in CONTACT_RESEARCH_FUNDING_TYPE) {
        return CONTACT_RESEARCH_FUNDING_TYPE[val].label
      }
      return null
    },
    originTypeLabel (val) {
      if (val in ORIGIN_TYPE) {
        return ORIGIN_TYPE[val].label
      }
      return null
    },
    advDestinationLabel (val) {
      if (val in ADV_DESTINATIONS) {
        return ADV_DESTINATIONS[val].label
      }
      return null
    },
    videoProviderLabel (val) {
      if (val in VIDEO_PROVIDER) {
        return VIDEO_PROVIDER[val].label
      }
      return null
    },
    calendarReportsLabel (val) {
      if (val in CALENDAR_REPORTS) {
        return CALENDAR_REPORTS[val].label
      }
      return null
    },
    searchBudgetMaxLabel (val) {
      if (val in SEARCH_BUDGET_MAX) {
        return SEARCH_BUDGET_MAX[val].label
      }
      return null
    },
    reminderDateLabel (val) {
      if (val in REMINDER_DATE) {
        return REMINDER_DATE[val].label
      }
      return null
    }
  },
  data () {
    return {
      programPicturePlaceholder: PROGRAM_PICTURE_PLACEHOLDER,
      contactCspData: CONTACT_CSP,
      matrimonalStatusData: MATRIMONIAL_STATUS_CHOICES,
      familySituationData: FAMILY_SITUATION_CHOICES,
      profilTypeData: PROFIL_TYPES_CHOICES,
      taxDispositifsData: TAX_DISPOSITIFS_CHOICES,
      statusData: STATUS_CHOICES,
      workflowStatusData: WORKFLOW_CHOICES,
      programStepProgressData: PROGRAM_PROGRESS_STEP_CHOICES,
      exposureData: LOT_EXPOSURES,
      naturesData: LOT_NATURES,
      typesData: LOT_TYPES,
      typesFilterData: LOT_TYPES_FILTER,
      floorsData: LOT_FLOORS,
      annexesData: LOT_ANNEX_TYPES,
      optionStatusData: OPTION_STATUS,
      advStatusData: ADV_STATUS,
      denunciationStatusData: DENUNCIATION_STATUS,
      contactResearchFundingData: CONTACT_RESEARCH_FUNDING_TYPE,
      contactResearchData: CONTACT_RESEARCH_TYPE,
      programDocumentsNameData: PROGRAM_DOCUMENTS_NAME,
      lotDocumentsNameData: LOT_DOCUMENTS_NAME,
      originTypeData: ORIGIN_TYPE,
      programCertifications: PROGRAM_CERTIFICATIONS,
      advDestinations: ADV_DESTINATIONS,
      videoProviders: VIDEO_PROVIDER,
      mapStyle: MAP_STYLE,
      regionsData: REGIONS,
      calendarReportsData: CALENDAR_REPORTS,
      searchBudgetMaxData: SEARCH_BUDGET_MAX,
      reminderDateData: REMINDER_DATE,
      stockBudgetData: STOCK_BUDGET,
      stockBudgetIgnoreData: STOCK_BUDGET_IGNORE,
      defaultStateLabelData: DEFAULT_STATE_LABEL,
      lotDefaultTypeLabelData: LOT_DEFAULT_TYPE_LABEL
    }
  },
  computed: {
    ...mapState(['currentUser', 'profilsData', 'states', 'isPromoteurMode', 'isDistributeurMode', 'allStates', 'configs']),
    annexes () {
      return this.annexesData
    },
    exposure () {
      return this.exposureData
    },
    natures () {
      return this.naturesData
    },
    status () {
      const tmp = Object.assign(this.statusData)
      return Object.values(tmp).filter(x => !x.needProfile || (x.needProfile && x.needProfile.includes(this.currentUser.profil_type)))
    },
    contactCspList () {
      return Object.values(this.contactCspData)
    },
    taxDispositifsList () {
      return Object.values(this.taxDispositifsData)
    },
    programCertificationsList () {
      return sortBy(Object.values(this.programCertifications), 'label')
    },
    profils () {
      return this.profilsData
    },
    optionStatus () {
      return this.optionStatusData
    },
    denunciationStatus () {
      return this.denunciationStatusData
    },
    matrimonalStatusList () {
      return Object.values(this.matrimonalStatusData)
    },
    familySituationList () {
      return Object.values(this.familySituationData)
    },
    profilTypeList () {
      return sortBy(Object.values(this.profilTypeData), 'label').map(p => p.value)
    },
    profilPkList () {
      return sortBy(this.profilsData, 'name').map(p => p.pk)
    },
    profilOrderList () {
      if (this.profilsData) {
        let profils = this.profilsData.map(x => Object.assign({}, this.profilTypeData[x.type], x))
        return sortBy(profils, 'order')
      }
    },
    trimestrialsChoices () {
      let choices = []
      let currentYear = new Date()
      currentYear = currentYear.getFullYear()
      let minYear = currentYear
      let maxYear = currentYear + 6
      let currrentQuarter = `${currentYear}${moment().format('Q')}`
      for (let year = minYear; year < maxYear; year++) {
        for (let trim = 1; trim <= 4; trim++) {
          let label = `${trim}T ${year}`
          if (label.split('T ').reverse().join('') > currrentQuarter) {
            let value = parseInt(year.toString() + trim.toString())
            choices.push([value, label])
          }
        }
      }
      return choices
    },
    trimestrialsChoicesByYear () {
      let choices = {}

      for (let choice of this.trimestrialsChoices) {
        let value = choice[0].toString()
        let year = value.substring(0, 4)
        if ((year in choices) === false) {
          choices[year] = [[], year]
        }
        choices[year][0].push(value)
      }

      return Object.values(choices).map(x => {
        x[0] = x[0].join(';')
        return x
      })
    },
    trimestrialsChoicesByYearObj () {
      let choices = {
        '0': {
          label: 'Livré',
          value: this.pastTrimestrialsChoices.map(x => {
            return x[0].toString()
          })
        }
      }

      for (let choice of this.trimestrialsChoices) {
        let value = choice[0].toString()
        let year = value.substring(0, 4)
        if ((year in choices) === false) {
          choices[year] = {value: [], label: year}
        }
        choices[year].value.push(value)
      }

      return Object.values(choices)
    },
    pastTrimestrialsChoices () {
      let choices = []
      let currentYear = new Date()
      currentYear = currentYear.getFullYear()
      let minYear = currentYear - 3
      let maxYear = currentYear + 1
      let currrentQuarter = `${currentYear}${moment().format('Q')}`
      for (let year = minYear; year < maxYear; year++) {
        for (let trim = 1; trim <= 4; trim++) {
          let label = `${trim}T ${year}`
          if (label.split('T ').reverse().join('') <= currrentQuarter) {
            let value = parseInt(year.toString() + trim.toString())
            choices.push([value, label])
          }
        }
      }
      return choices
    },
    pastTrimestrialsChoicesByYear () {
      let choices = {}

      for (let choice of this.pastTrimestrialsChoices) {
        let value = choice[0].toString()
        let year = value.substring(0, 4)
        if ((year in choices) === false) {
          choices[year] = [[], year]
        }
        choices[year][0].push(value)
      }

      return Object.values(choices).map(x => {
        x[0] = x[0].join(';')
        return x
      })
    },
    calendarReports () {
      return this.calendarReportsData
    },
    statusList () {
      return Object.values(this.statusData)
    },
    optionStatusList () {
      return Object.values(this.optionStatusData)
    },
    advStatusList () {
      return Object.values(this.advStatusData)
    },
    denunciationStatusList () {
      return Object.values(this.denunciationStatusData)
    },
    workflowStatusList () {
      let values = Object.values(this.workflowStatusData)
      if (this.isPromoteurMode) {
        values = values.filter(x => x.value !== 'private')
      }
      return values
    },
    programStepProgressList () {
      if (!this.configs) return
      return Object.values(this.programStepProgressData).filter(x => x.country.includes(this.configs.COUNTRY)).map(x => {
        return {
          label: x.label[this.configs.COUNTRY],
          value: x.value
        }
      })
    },
    exposureList () {
      return Object.values(this.exposureData)
    },
    floorsList () {
      return Object.values(this.floorsData)
    },
    naturesList () {
      if (!this.configs) return
      return Object.values(this.naturesData).filter(x => x.country.includes(this.configs.COUNTRY)).map(x => {
        return {
          label: x.label[this.configs.COUNTRY],
          value: x.value
        }
      })
    },
    typesList () {
      if (!this.configs) return
      return Object.values(this.typesData).filter(x => x.country.includes(this.configs.COUNTRY)).map(x => {
        return {
          label: x.label[this.configs.COUNTRY],
          value: x.value
        }
      })
    },
    typesFilterList () {
      if (!this.configs) return
      return Object.values(this.typesFilterData).map(x => {
        return {
          label: x.label[this.configs.COUNTRY],
          value: x.value
        }
      })
    },
    annexesList () {
      return Object.values(this.annexesData).filter(x => !['parking', 'parking_ext', 'parking_int', 'garage'].includes(x.value))
    },
    contactResearchList () {
      return Object.values(this.contactResearchData)
    },
    contactResearchFundingList () {
      return Object.values(this.contactResearchFundingData)
    },
    originTypeList () {
      return Object.values(this.originTypeData)
    },
    advDestinationsList () {
      return Object.values(this.advDestinations)
    },
    videoProvidersList () {
      return Object.values(this.videoProviders)
    },
    regionsList () {
      return this.regionsData
    },
    searchBudgetMaxList () {
      let list = {}
      Object.keys(this.searchBudgetMaxData).forEach((x, i) => {
        if (Object.values(this.searchBudgetMaxData)[i].currency === this.configs.CURRENCY) {
          list[x] = Object.values(this.searchBudgetMaxData)[i]
        }
      })
      return list
    },
    stockBudgetList () {
      if (!this.configs) return
      return this.stockBudgetData.filter((x, i) => {
        return Array.isArray(x.currency) ? x.currency.includes(this.configs.CURRENCY) : x.currency === this.configs.CURRENCY
      }).map(x => x.label)
    },
    stockBudgetIgnoreList () {
      if (!this.configs) return
      return this.stockBudgetIgnoreData.filter((x, i) => {
        return Array.isArray(x.currency) ? x.currency.includes(this.configs.CURRENCY) : x.currency === this.configs.CURRENCY
      }).map(x => x.label)
    },
    stockBudgetStep () {
      if (!this.configs) return
      let step = STOCK_BUDGET_STEP.find(x => x.currency === this.configs.CURRENCY)
      return step ? step.value : STOCK_BUDGET_STEP[0].value
    },
    reminderDateList () {
      return this.reminderDateData
    },
    regionsCoordinates () {
      return this.regionsData.map(x => x.coordinates)
    },
    filteredAllRegions () {
      if (!this.allStates || !this.allStates.length) return []
      let arr = []
      this.allStates.forEach(x => {
        this.regionsList.forEach(y => {
          if (y.states.includes(x.code)) arr.push(Object.assign(x, {region: y.label}))
        })
      })
      let grouped = groupBy(arr, 'region')
      return sortBy(Object.keys(grouped).map(key => {
        return {region: key, states: grouped[key]}
      }), 'region')
    },
    filteredRegions () {
      if (!this.states || !this.states.length) return []
      let arr = []
      this.states.forEach(x => {
        this.regionsList.forEach(y => {
          if (y.states.includes(x.code)) arr.push(Object.assign(x, {region: y.label}))
        })
      })
      let grouped = groupBy(arr, 'region')
      return sortBy(Object.keys(grouped).map(key => {
        return {region: key, states: grouped[key]}
      }), 'region')
    },
    defaultStateLabel () {
      if (!this.configs) return
      let stateLabel = this.defaultStateLabelData.find(x => x.country === this.configs.COUNTRY)
      return stateLabel || this.defaultStateLabelData[0]
    },
    lotDefaultTypeLabel () {
      if (!this.configs) return ''
      if (this.$configs.COUNTRY in this.lotDefaultTypeLabelData) {
        return this.lotDefaultTypeLabelData[this.$configs.COUNTRY]
      } else return this.lotDefaultTypeLabelData.FRA
    }
  },
  methods: {
    programStepProgressLabel (val) {
      if (!this.configs) return
      if (val in PROGRAM_PROGRESS_STEP_CHOICES) {
        return PROGRAM_PROGRESS_STEP_CHOICES[val].label[this.configs.COUNTRY]
      }
      return null
    },
    natureLabel (val) {
      if (!this.configs) return
      if (val in LOT_NATURES) {
        return LOT_NATURES[val].label[this.configs.COUNTRY]
      }
      return null
    },
    lotTypeLabel (val) {
      if (!this.configs) return
      if (val in LOT_TYPES) {
        return LOT_TYPES[val].label[this.configs.COUNTRY]
      }
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DefaultValues.js